module.exports = "/src/views/player/help/images/pd2.jpg";